import type { Icon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/Button';

export interface SidebarMenuHeaderConfig {
    title: string;
    icon?: Icon;
    action?: {
        icon: Icon;
        ariaLabel: string;
        onClick: () => void;
        disabled?: boolean;
        testId?: string;
    };
}

interface SidebarMenuHeaderProps {
    header: SidebarMenuHeaderConfig;
}

export function SidebarMenuHeader({ header }: SidebarMenuHeaderProps) {
    const HeaderIcon = header.icon;
    const ActionIcon = header.action?.icon;
    return (
        <div className="flex items-center justify-between gap-1.5 shrink-0">
            <div className="flex items-center gap-1.5">
                {HeaderIcon && (
                    <HeaderIcon className="size-4 shrink-0 text-grey-300" />
                )}
                <h3 className="text-sm-medium text-white-100">
                    {header.title}
                </h3>
            </div>
            {header.action && ActionIcon && (
                <Button
                    variant="ghost"
                    size="small"
                    className="shrink-0 size-8 p-0"
                    onClick={header.action.onClick}
                    disabled={header.action.disabled}
                    aria-label={header.action.ariaLabel}
                    data-testid={header.action.testId}
                >
                    <ActionIcon className="size-4" />
                </Button>
            )}
        </div>
    );
}
